import { IInventoryPage } from '../../../inventory-page.interface';


export const SETTINGS_RESEARCH_EMAIL_NOTIFICATIONS_PAGE: IInventoryPage = {
	'route': '/settings/research/email-notifications',
	'title': 'Email Notification',
	'uiReference': [
		'Loading email notification settings',
		'TM Watchlist',
		'Event Reminder',
		'Close',
		'Email notifications',
		'Choose which Research updates are sent to your inbox.',
		'Help / Tutorial',
		'Unable to load notification settings',
		'Please try again to load your email notification preferences.',
		'Retry',
		'Mail',
		'Please enter valid email',
		'Save Changes',
		'Country',
		'Please select at least one country',
		'Remind',
		'before the event',
		'No notification settings available',
		'More Info',
		'&times;',
		'Go to Store',
		'See all Tutorials'
	],
	'sources': [
		'apps/flying-projects/frontend/webapp/src/app/pages/shared/setting/setting-routing.module.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/shared/setting/settings-pages/research/email-notification/email-notification.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/shared/setting/settings-pages/research/email-notification/email-notification.data.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/shared/setting/settings-pages/research/email-notification/email-notification.component.html'
	]
};
